import React from 'react';

import { useGetList } from '@vlabs/api/artemy/client';
import type { ListId } from '@vlabs/api/artemy/model';
import { PageHeader } from '@vlabs/monokit/shared/ui/page';
import { Breadcrumbs, Breadcrumb } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';

import { ListCardsActions } from './ListCardsActions';
import { routes } from '../../../../app/routes';

interface ListDetailsPageHeaderProps {
  listId: ListId;
}

export function ListDetailsPageHeader({ listId }: ListDetailsPageHeaderProps): React.JSX.Element {
  const { t } = useTranslation();
  const getList = useGetList(listId);
  return (
    <PageHeader
      actions={<ListCardsActions />}
      breadcrumbs={(
        <Breadcrumbs>
          <Breadcrumb
            caption={t('face-page:header.breadcrumbs.cards_and_lists')}
            href={generatePath(routes.cardsAndLists.activeTab, { activeTab: 'lists' })}
          />
          <Breadcrumb caption={t('list')} />
        </Breadcrumbs>
)}
      title={getList.data?.user_data ?? '-'}
    />
  );
}
